module.exports={
    "over_size_message":"アップロードした画像は10Mを超えています。 アップロードできるように圧縮の処理を行います。 アップロードを続行するには、「確認」をクリックしてください。",
    "file_type_error":"アップロードしたファイルは画像ではありません！ もう一度アップロードしてみてください。",
    "upload_error":"アップロードエラー! (エラーコード: 2000) 再試行してください",
    "watermark_remove_over_size":"アップロードした画像は5Mを超えています。 オンライン画像圧縮を使用してサイズを圧縮できます。 <a class=\"jump-link\" href=\"https://www.anymp4.com/ja/image-compressor-online/\">もっと多く</a>をクリックします。",
    "watermark_remove_file_type_error":"アップロードしたファイルは写真ではありません。もう一度アップロードしてください。",
    "watermark_remove_image_type_error":"画像形式はサポートされていません。 JPG、JPEG、PNG、BMPしかをサポートできません。 ",
    "watermark_remove_upload_error":"認識エラー（エラーコード：2001）、もう一度やり直してください...",
    "watermark_remove_processing":"画像を処理中...",
    "watermark_remove_not_save":"選択した範囲は削除します。 削除してもよろしいですか？",
    "watermark_remove_back_home":"今の状態は保存されません。ホームに戻りましょうか?",
    "watermark_remove_new_image":"今の状態は保存されません。 新しい写真を選択してもよろしいでしょうか?",
    "watermark_select":"選択",
    "watermark_select_area":"「削除」をクリックする前に、消去する透かしの領域を選択してください。",
    "watermark_beyond_4k":"選択した画像の解像度が4Kを超えています。 申し訳ありませんが、現在処理できません。",
    "watermark_beyond_pixel_1":"選択した画像の解像度は <span>%spx</span><span>&times;%spx</span>を超えています。 現在処理できませんので、再度選択してください。",
    "watermark_beyond_pixel_2":"訪問者は、 <span>%s</span> x <span>%spx </span>を超える解像度の<span>%s</span>画像のみを処理できます。ログインして引き続き使用してください。",
    "watermark_beyond_size_1":"選択した写真のサイズは<span>%sMB</span>を超えます。現在処理できませんので、再度選択してください。",
    "watermark_beyond_size_2":"選択した写真のサイズは<span>%sMB</span>を超えます。 訪問者は、<span>%sMB</span>以下の写真しか処理できません。ログインして続けます。",
    "no_user_down":"訪問者は オリジナル<span>%s</span> 写真しかダウンロードできません。 ログインしてダウンロードを続けてください。 また、ログイン後7日間の履歴を保持することができます。 <span>%spx</span>の画像のダウンロードを続行します。",
    "no_down_rights":"オリジナル品質のHD画像をダウンロードできません。プランをアップグレードしてください。 また低品質の<span>%spx</span>写真をダウンロードできます。",
    "error_40001":"エラーコード: 40001。こちらへ連絡してください。",
    "error_40099":"エラー: 40099。こちらへ連絡してください。",
    "down_btn":"ダウンロードは準備中です。しばらくお待ちください…",
    "noRemove_down_btn":"透かしを削除するにはまず範囲を選択してください。 削除したい透かしを選択して、「削除」ボタンをクリックしてください。 次に、画像をダウンロードできます。",
    "history_open":"変更した画像を開いて、しばらくお待ちください...",
    "maskRightsMonitor_info":"特典のアップグレードのページが新しいタブで開かれ、アップグレード後にプランが自動同期されます。",
    "maskLoginMonitor_info":"ランディングページが開きましたので、ログインを完了してください。 ログインまたは再登録が正常に完了すると、このページは自動的に同期されます。閉じないでください。",
    "photo_rights_info":" 今オリジナル品質の<span><i class=\"num\">2</i> HD 写真</span>をダウンロードできます。 <a href=\"https://account.anymp4.com\" target=\"_blank\">もっと詳細には>></a>",
    "rights_original":"「画像強化機能を使用して品質低下を減らす」設定をオンにするには、アカウントをアップグレードする必要があります。",
    "Brush":"ブラシ",
    "Lasso":"ラソ",
    "Polygonal":"多角形",
    "Eraser":"消しゴム",
    "Free":"フリー",
    "More":"もっと:",
    "Select":"選択",
    "Remove":"削除",
    "BrushSize":"ブラシサイズ:",
    "AspectRatio":"アスペクト比:",
    "Upload":"新しい写真",
    "History":"履歴",
    "Login":"ログイン",
    "MyAccount":"アカウント",
    "Logout":"ログアウト",
    "Usinghelp":"ヘルプ>>",
    "Enhancer":"写真強化機能を使用して、品質の低下を減らします",
    "Download":"ダウンロード",
    "Guide":"ガイド",
    "Polygonal1":"多角形:",
    "Polygonal_info":"マウスの左ボタンをクリックして、一度に1つのポイントを識別します。",
    "Lasso1":"ラソ:",
    "Lasso_info":"マウスの左ボタンを長押しして、透かし領域をラソで囲みます。",
    "Brush1":"ブラシ:",
    "Brush_info":"マウスの左ボタンを長押しして、正確に選択します。",
    "Eraser1":"消しゴム:",
    "Eraser_info":"選択した領域から不要な部分を消去します。",
    "Click":"クリック",
    "the":"この",
    "click_info":"ボタンをクリックして、不要な透かしの除去を開始します。",
    "PleaseUploadImages":"画像をアップロードしてください。",
    "CropInfo":"透かしの削除が完了したら、「削除」ボタンをクリックして画像を切り抜いてから保存するか、[ダウンロード]ボタンをクリックして現在の画像を直接保存します。",
    "Crop":"クロップ",
    "Back":"戻り",
    "DownloadCropped":"クロップしたものをダウンロード",
    "Cancel":"キャンセル",
    "FreeWatermarkRemover":"フリー ウォーターマーク削除",
    "Processing":"処理中...",
    "NewImage":"新しい写真",
    "Retry":"再試行",
    "Yes":"Yes",
    "No":"No",
    "FailureFeedback":"フォードバックに失敗しました",
    "removeTip":"透かし領域を選択したら、「削除」をクリックして透かしを消去してください。",
    "rightDown":"低品質の画像をダウンロードします",
    "history_will":"期限切れになります",
    "Expired":"(期限切れ)",
	"uploadImage":"写真を追加",
    "uploadImageInfo":"またはここに写真をドロップ透かしを削除します！",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"無制限",
    "watermark_beyond_pixel_3":"選択した写真は<span>%s&倍;% 解像度</span>を超えました。プランをアップグレードしてください。",
    "watermark_beyond_size_3":"選択した写真は<span>%sMB</span>を超えました。プランをアップグレードしてください。",
    "no_user_login":"ログインユーザーはTWOオリジナル写真ダウンロードベネフィットを取得できます。<span class=\"loginMaskbtn\">ログイン>></span>",
    "Upgrade":"アップデート",
    "Loading":"ロード中...",
    "SelectAll":"全て選択",
    "Open":"開く",
    "Delete":"削除",
    "Clear":"無効なものを削除",
    "noHistory":"履歴なし",
    "Close":"閉じる",
    "buyUserInfo":"おめでとう！ 正常にアップグレードされました。 ホームページに戻り、本製品をご利用ください。",
    "buyNoUserInfo":"おめでとう！ 正常にアップグレードされました。アップグレード中に残した電子メール アドレスにバインドされています。 <span class=\"loginMaskbtn\">ベネフィットを利用するためログイン</span>には、メールアドレスに登録またはリンクされたアカウントを使用してください。",
    "GetStarted":"すぐ開始",
    "AccessTo":"アクセス:",
    "imagesOfwatermarkremoval":"写真の透かしを削除",
    "upTo":"最大",
    "perImage":"写真ごと",
    "Support":"サポート",
    "resolution":"解像度",
    "PrepaidPackage":"前払いパッケージ",
    "PayasYouGo":"即金払い",
    "TaxIncl":"税込",
    "Checkout":"チェックアウト",
    "imagesDay":"写真/日",
    "imagesMonthly":"写真/月",
    "image":"写真",
    "images":"写真",
    "imageSize":"写真サイズ",
    "buyInfo1":"サードパーティの <span>エンハンサー</span> の統合",
    "buyInfo2":"編集履歴は7日間有効です",
    "buyInfo3":"優先処理",
    "buyInfo4":"7x24 顧客サポート",
    "buyInfo5":"24時間後に期限切れ",
    "buyInfo6":"サブスクリプションはありません。 自動更新なし！",
    "buyInfo7":"いつでもいつまでも使える",
    "dayPlan":"1日間 ライセンス",
    "Lifetime":"ライフタイム",
    "note":"<span>注意</span>: 購入したプランは、購入時に提供されたメールアドレスに関連付けられています。プランを正常に使用するには、同じメールアドレスで登録またはログインしてください。"
}